// Реестр анкет-мастеров шаблонов (SCRIPTS-MODE Ф3). Типы и хелперы — core.ts,
// каждая анкета — свой def-файл рядом. Новая анкета = def-файл + строка в реестре.
import type { BotAccountChannel } from '@scriptera/ui/scenario';
import type { TemplateWizardDef } from './core';
import { broadcastWizard } from './broadcast';
import { chainWizard } from './chain';
import { giftIg } from './gift-ig';
import { keywordBotIg } from './keyword-bot-ig';
import { subscribeCheckTg } from './subscribe-check-tg';
import { triggerIg } from './trigger-ig';
import { triggerTg } from './trigger-tg';

export * from './core';
// Помощники мастера рассылки (письма плоскими ответами) — их зовёт панель мастера.
export * from './broadcast';
// Помощники мастера ЦЕПОЧКИ (письма плоскими ответами, стабильные id) — их зовут
// панель мастера и движок цепочек.
export * from './chain';

/** ТРИ МАСТЕРА-ШАБЛОНА, и ровно три (владелец 31.08.2026): кодовое слово в
 *  комментарии (Instagram), подарок за подписку (Instagram) и подарок за подписку
 *  (Telegram). Каталог шаблонов показывает только шаблоны С мастером (BUILDER_HIDDEN),
 *  поэтому этот список и есть витрина. */
export const TEMPLATE_WIZARDS: TemplateWizardDef[] = [keywordBotIg, giftIg, subscribeCheckTg];

/** МАСТЕРА ЗАПУСКА (TRIGGER-WIZARD, владелец 15.08.2026): один деф на КАНАЛ, шаблона у
 *  них нет — ими открывается любой шаблон сети, у которого своего мастера не заведено.
 *  Список отдельный НАРОЧНО: витрина каталога (wizardForSource) метит палочкой «мастер
 *  настройки» только шаблоны со СВОЕЙ анкетой, и мастер запуска такой метки не даёт. */
export const TRIGGER_WIZARDS: TemplateWizardDef[] = [triggerTg, triggerIg];

/** МАСТЕРА БЕЗ ШАБЛОНА (standalone, ТЗ 16): схему собирают сами. В витрине шаблонов их
 *  нет вовсе, поэтому и список отдельный — в TEMPLATE_WIZARDS такой деф с пустым
 *  `templateSource` ловился бы поиском по слагу шаблона (wizardForSource('')). */
export const STANDALONE_WIZARDS: TemplateWizardDef[] = [broadcastWizard, chainWizard];

const ALL_WIZARDS: TemplateWizardDef[] = [
  ...TEMPLATE_WIZARDS,
  ...TRIGGER_WIZARDS,
  ...STANDALONE_WIZARDS,
];

export function wizardById(id: string): TemplateWizardDef | undefined {
  return ALL_WIZARDS.find((w) => w.id === id);
}

export function wizardForSource(source: string): TemplateWizardDef | undefined {
  return TEMPLATE_WIZARDS.find((w) => w.templateSource === source);
}

/** Мастер запуска канала: 'telegram' | 'instagram'. Канала без мастера (сайт, ВК, MAX)
 *  просто нет в списке — карточка такого шаблона открывается по-старому, сразу схемой. */
export function triggerWizardForChannel(channel: string): TemplateWizardDef | undefined {
  return TRIGGER_WIZARDS.find((w) => w.accountChannel === (channel as BotAccountChannel));
}

/** Анкеты семейства «один мастер на обе сети» (включая саму def). Панель мастера
 *  собирает по ним общий список аккаунтов; выбор аккаунта переключает активную анкету. */
export function wizardSiblings(def: TemplateWizardDef): TemplateWizardDef[] {
  if (!def.family) return [def];
  return ALL_WIZARDS.filter((w) => w.family === def.family);
}
